import { useEffect, useId, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { initials } from '../utils/userDisplay.js';

export function UserMenu({ profileTo, roleLabel }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const id = useId();
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onPointerDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setOpen(false);
      }
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  if (!user) {
    return null;
  }

  return (
    <div ref={rootRef} className={`user-menu${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="user-menu-trigger"
        aria-expanded={open}
        aria-haspopup="true"
        aria-controls={id}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="user-avatar" aria-hidden>
          {initials(user.name)}
        </span>
        <span className="user-menu-meta">
          <span className="user-menu-name">{user.name}</span>
          {roleLabel ? <span className="user-menu-role">{roleLabel}</span> : null}
        </span>
      </button>
      <div id={id} className="user-menu-panel" role="menu">
        <Link to={profileTo} role="menuitem" className="user-menu-item" onClick={() => setOpen(false)}>
          Profile settings
        </Link>
        <button
          type="button"
          role="menuitem"
          className="user-menu-item user-menu-item--button"
          onClick={async () => {
            setOpen(false);
            await logout();
            navigate('/', { replace: true });
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
